import React, {
  useCallback,
} from 'react';
import {
  connect,
  useDispatch,
} from 'react-redux';
import {
  withRouter,
  RouteComponentProps,
} from 'react-router-dom';
import GoogleLogin from 'react-google-login';

import Config from 'configuration';

import { googleLogin } from 'actions/user';
import google from 'assets/img/google.png';

import redirectAfterLogin from './redirectAfterLogin';

export function GoogleLoginContainer({
  history,
  label,
}: Props) {
  const { googleId } = Config;

  const dispatch = useDispatch();

  const handleSuccess = useCallback(async (response) => {
    // NOTE: this is a Google-provided access token, not our JWT
    const { access_token: googleAccessToken } = response.getAuthResponse();
    const data: any = await dispatch(googleLogin(googleAccessToken));
    // Send the user where they need to go next
    redirectAfterLogin(history, data);
  }, [dispatch, history]);

  const handleFailure = useCallback((err) => {
    console.error('google error: ', err);
  }, []);

  return (
    <GoogleLogin
      clientId={googleId}
      className="button button--google"
      autoLoad={false}
      buttonText={label}
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      render={renderProps => (
        <button
          className="button button--google"
          onClick={renderProps?.onClick}
          type="button"
        >
          <span>
            <img
              src={google}
              alt="Google"
            />
            {' '}
            {label}
          </span>
        </button>
      )}
    />
  );
}

type OwnProps = { label: string };
type Props = OwnProps & RouteComponentProps;

export default withRouter(connect()(GoogleLoginContainer));